export default function scrollableLayout(context: {
  content: {width: number; height: number};
}) {
  return context.content.width / context.content.height >= 0.8;
}
